import { render, staticRenderFns } from "./AddNewConsultant.vue?vue&type=template&id=2848238c&"
import script from "./AddNewConsultant.vue?vue&type=script&lang=js&"
export * from "./AddNewConsultant.vue?vue&type=script&lang=js&"
import style0 from "./AddNewConsultant.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports